import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "formatNumber",
})
export class FormatNumberPipe implements PipeTransform {
  transform(value: any, decimalPlaces: number = 1): string {
    if (value === null || value === undefined || value === "") return "$0.00";

    const num = parseFloat(value);
    if (isNaN(num)) return "$0.00";

    const formattedValue = (num: number) => num.toFixed(decimalPlaces);

    if (num >= 1_000_000) {
      return `$${formattedValue(num / 1_000_000)}M`;
    } else if (num >= 1_000) {
      return `$${formattedValue(num / 1_000)}K`;
    }

    return `$${formattedValue(num)}`;
  }
}
